


























































































import Vue from "vue";
import store, { GeneralLedgerStore } from "../services/store";
import dayjs from "dayjs";
import { Period } from "../models/PeriodModell";
import api from "../services/api";
import eventBus from "@/services/eventBus";
import KendoGridCols from "@/models/KendoGridCols";
import { t } from "@/plugins/i18n";

interface Data {
  store: GeneralLedgerStore;
  periodsThatHaveChangedStatus: Period[];
}

interface Computed {
  periods: Period[];
  periodsCols: KendoGridCols[];
  yearBeingWatched: number;
}

export default Vue.extend<Data, {}, Computed, {}>({
  data(): Data {
    return {
      store,
      periodsThatHaveChangedStatus: [],
    };
  },
  computed: {
    periods() {
      return store.periods;
    },
    periodsCols: () => [
      { field: "period", title: t("Periodus") },
      { field: "startDate", title: t("KezdoDatum"), cell: "startDateTemp" },
      { field: "endDate", title: t("VegDatum"), cell: "endDateTemp" },
      {
        field: "mustClose",
        title: t("GeneralLedger_ZarasKoteles"),
        cell: "mustCloseTemp",
      },
      { field: "accDate", title: t("GeneralLedger_KonyvelesKezdete"), cell: "accDateTemp" },
      { field: "status", title: t("Allapot"), cell: "statusTemp", width:200 },
      { field: "createdOn", title: t("GeneralLedger_LetrehDatum"), cell: "createdOnTemp" },
      { field: "creator", title: t("GeneralLedger_LetrehFelh_2") },
      { field: "closeDate", title: t("GeneralLedger_ZarasDatuma"), cell: "closeDateTemp" },
    ],
    yearBeingWatched(){
      return this.store.yearBeingChecked;
    }
  },
  watch: {
    yearBeingWatched(){
      this.store.setPeriods(this.yearBeingWatched)
    }
  },

  methods: {
    toDate(item: string) {
      return dayjs(item)
        .format("YYYY-MM-DD")
        .replaceAll("-", ".");
    },
    formatDate(date: Date) {
      return dayjs(date)
        .format("YYYY-MM-DD-HH:mm")
        .replace("-", ".")
        .replace("-", ".")
        .replace("-", " ");
    },
    isCloseDateSet(item: string) {
      return item === "1901.01.01" ? false : true;
    },
    async savePeriodsStatusChanges() {
      const result = await api.SavePeriodsStatusChanges(
        this.periodsThatHaveChangedStatus
      );
      if (result) {
        eventBus.$emit("success", t("SikeresMentes"));
        this.periodsThatHaveChangedStatus=[]
      } else {
        eventBus.$emit("error", t("GeneralLedger_SikertelenVoltAMentes"));
      }
    },
  },
});
